import $ from "jquery";
var Thanks = /** @class */ (function () {
    function Thanks() {
        var _this = this;
        $(window).resize(function () {
            _this.resize();
        });
        $(".broker").each(function (index, el) {
            _this.bindBrokerEvents(el);
            _this.checkIfToggleBioNeeded(el);
        });
    }
    Thanks.prototype.resize = function () {
        var _this = this;
        $(".broker").each(function (index, el) {
            _this.checkIfToggleBioNeeded(el);
        });
    };
    Thanks.prototype.bindBrokerEvents = function (brokerEl) {
        var bio = $(brokerEl).find(".broker-bio");
        var bioToggle = $(brokerEl).find(".broker-bio-toggle");
        bioToggle.on("click", function () {
            if (bio.hasClass("expanded")) {
                bio.removeClass("expanded");
            }
            else {
                bio.addClass("expanded");
            }
        });
    };
    Thanks.prototype.checkIfToggleBioNeeded = function (brokerEl) {
        var lines = 4;
        var lineHeight = 17.5;
        var threshold = (lines + 0.5) * lineHeight;
        var bio = $(brokerEl).find(".broker-bio");
        var bioContent = bio.find(".broker-bio-content");
        var height = bioContent.height();
        if (height > threshold) {
            bio.addClass("toggle-needed");
        }
        else {
            bio.removeClass("toggle-needed");
            bio.removeClass("expanded");
        }
    };
    return Thanks;
}());
export { Thanks };
